import {MultiTargetRelation} from '../MultiTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {type ISketchObject} from "../../../../../mesh/sketch";

let count = 0;

/**
 * 判断对象是否为圆系共径关系定义。
 *
 * @param value 待判断对象。
 * @returns 是否为圆系共径关系定义。
 */
export function isCircleCoradialConstraint(value: object): value is CircleCoradialConstraint {
    return Reflect.get(value, "isCircleCoradialConstraint") === true;
}

/**
 * 圆系共圆心同半径关系定义。
 *
 * 本对象只保存领域身份和目标绑定；参数编译器负责生成圆心重合与半径相等方程。
 */
export class CircleCoradialConstraint extends MultiTargetRelation<ISketchObject> {
    /** 跨包识别圆系共径关系的稳定标记。 */
    public readonly isCircleCoradialConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Coradial;

    /** 创建共径关系定义并分配显示名称。 */
    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** @returns 关系面板使用的中文基础显示名。 */
    public override get baseDisplayName(): string {
        return '共圆心同半径';
    }

}
